export default "__VITE_ASSET__756fa5c1__"